export default class ProductUtils {
    static createReviewStarRange(number: number) {
        let loopItems: number[] = [];
        for (var i = 1; i <= number; i++) {
            loopItems.push(i);
        }
        return loopItems;
    }

    static getCategoryNameByDimensionId(dimId: string) : string {
        switch (dimId) {
            case '100047':
                return 'fashion';
            case '128153':
                return 'shoes,handbags,luggage';
            case '100101':
                return 'jewellery';
            case '100038':
                return 'beauty';
            case '100071':
                return 'home,garden';
            case '100072':
                return 'kitchen';
            case '2058731':
                return 'health,fitness';
            case '100073':
                return 'electronics';
            case '2037576':
                return 'clearance';
            default:
                return 'clearance';
        }
    }
}


// WEBPACK FOOTER //
// C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/ngc-webpack??ref--0-1!C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/angular2-template-loader!../product-utils.ts